import { DDSButton, DDSTabs, DDSTypography } from 'den-design-system'
import React, { CSSProperties } from 'react'

import { Button } from '../../../New/Button/Button'
import { Download } from '@carbon/icons-react'
import Tooltip from '../../../New/Tooltip/Tooltip'
import pallete from '../../../../global/newPallete'
import { useStoreContext } from '../../../../store/StoreContext'

interface TabsProps {
  tabOptions: any[]
  id?: string
  className?: string
  limitExceed?: any
  tooltipLabel?: any
  style?: CSSProperties
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
  showActionButton?: boolean
  actionButtonLabel?: string
  onActionButtonPress?: () => void
  tabOptionsStyle?: CSSProperties
  childrenStyle?: CSSProperties
  onChange?: (activeTab: string) => void
  onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void
  disabled?: boolean
  activeTab?: string
  actionButtonDisabled?: boolean
  exportOption?: boolean
}
const Tabs: React.FC<TabsProps> = ({
  tabOptions,
  id,
  className,
  style,
  showActionButton,
  actionButtonLabel,
  limitExceed,
  onActionButtonPress,
  onBlur,
  onChange,
  childrenStyle,
  tooltipLabel,
  tabOptionsStyle,
  disabled,
  activeTab,
  actionButtonDisabled,
  exportOption = false
}) => {
  const store = useStoreContext()
  return (
    <div
      className={`relative override-tabs ${disabled && 'cursor-not-allowed'}`}
    >
      <div className={`${disabled && 'pointer-events-none'}`}>
        <DDSTabs
          tabOptions={tabOptions}
          id={id}
          className={className}
          style={style}
          onChange={onChange}
          onBlur={onBlur}
          tabOptionsStyle={tabOptionsStyle}
          childrenStyle={childrenStyle}
          activeTab={activeTab}
        />
      </div>
      {showActionButton && (
        <div className='absolute top-0 right-0'>
          {limitExceed ? (
            <Tooltip
              id={`tooltip-limit-exceed`}
              label={tooltipLabel}
              className='override-tooltip-arrow max-w-[90%] break-all'
            >
              <div>
                <DDSButton
                  label={
                    <DDSTypography.Paragraph
                      size='para'
                      variant='semiBold'
                      color={pallete.colors.textDark1}
                    >
                      {actionButtonLabel}
                    </DDSTypography.Paragraph>
                  }
                  shape='roundedRectangle'
                  onClick={onActionButtonPress}
                  disabled={
                    store.userStore.getNoActiveSubscription() || limitExceed
                  }
                />
              </div>
            </Tooltip>
          ) : !exportOption ? (
            <DDSButton
              label={
                <DDSTypography.Paragraph
                  size='para'
                  variant='semiBold'
                  color={pallete.colors.textDark1}
                >
                  {actionButtonLabel}
                </DDSTypography.Paragraph>
              }
              shape='roundedRectangle'
              onClick={onActionButtonPress}
              disabled={
                store.userStore.getNoActiveSubscription() ||
                actionButtonDisabled
              }
            />
          ) : (
            <Button
              id='outline-button'
              label='Export'
              disabled={
                store.userStore.getNoActiveSubscription() ||
                actionButtonDisabled
              }
              type='neutral'
              size='small'
              onClick={onActionButtonPress}
              startIcon={<Download color={pallete.colors.neuButtonText} />}
            />
          )}
        </div>
      )}

      <hr className='flex w-full absolute h-[1px] top-[46.5px]' />
    </div>
  )
}
export default Tabs
